"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/*import AMapLoader from '@amap/amap-jsapi-loader';*/
var _default = exports.default = {
  name: 'moveDetail',
  data: function data() {
    return {
      dialogRoadsVisible: false,
      map: null,
      marker: null
    };
  },
  methods: {
    /*initMap(lineArr) {
      AMapLoader.load({
        key: '3072a11ee675b099a1f5a96c8418978f', // 申请好的Web端开发者Key，首次调用 load 时必填
        version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [''] // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then((AMap) => {
          this.map = new AMap.Map('container', {
            resizeEnable: true,
            center: lineArr[0],
            zoom: 17
          });
          this.marker = new AMap.Marker({
            map: this.map,
            position: lineArr[0],
            icon: 'https://a.amap.com/jsapi_demos/static/demo-center-v2/car.png',
            offset: new AMap.Pixel(-13, -26)
          });
          const _this = this;
          AMap.plugin('AMap.MoveAnimation', function () {
            // 绘制轨迹
            var polyline = new AMap.Polyline({
              map: _this.map,
              path: lineArr,
              showDir: true,
              strokeColor: '#28F', //线颜色
              // strokeOpacity: 1,     //线透明度
              strokeWeight: 6 //线宽
              // strokeStyle: "solid"  //线样式
            });
              var passedPolyline = new AMap.Polyline({
              map: _this.map,
              // path: lineArr,
              strokeColor: '#AF5', //线颜色
              // strokeOpacity: 1,     //线透明度
              strokeWeight: 6 //线宽
              // strokeStyle: "solid"  //线样式
            });
              _this.marker.on('moving', function (e) {
              polyline.setPath(e.passedPath);
            });
            _this.map.setFitView();
            const that = _this;
            // 开始动画
            window.startAnimation = function startAnimation() {
              that.marker.moveAlong(lineArr, {
                // 每一段的时长
                duration: 500,
                // JSAPI2.0 是否延道路自动设置角度在 moveAlong 里设置
                autoRotation: true
              });
            };
            //  暂停动画
            window.pauseAnimation = function pauseAnimation() {
              that.marker.pauseMove();
            };
            //  继续动画
            window.resumeAnimation = function resumeAnimation() {
              that.marker.resumeMove();
            };
            //  停止动画
            window.stopAnimation = function stopAnimation() {
              that.marker.stopMove();
            };
          });
        })
        .catch((e) => {
          console.log(e);
        });
    }*/
  }
  /* mounted() {
     //DOM初始化完成进行地图初始化
     this.initMap();
   }*/
};